import { useEffect } from "react";
import { useFormState, useWatch } from "react-hook-form";

import { yup } from "utils";

import { validationSchema } from "./useNewUserInfoForm";

const getValidUsers = (newUserInfo, defaultRole) => {
  const seenEmails = new Set();

  return newUserInfo.map((user) => {
    try {
      const hasAnyData = user.firstName || user.lastName || user.email;
      if (!hasAnyData) return { ...user, valid: false };

      const singleUserSchema = yup.object().shape(validationSchema());
      singleUserSchema.validateSync(user, { abortEarly: false });

      if (!user.firstName || !user.lastName || !user.email)
        return { ...user, valid: false };

      if (seenEmails.has(user.email)) return { ...user, valid: false };

      seenEmails.add(user.email);

      return { ...user, valid: true, roleId: user.roleId || defaultRole.id };
    } catch {
      return { ...user, valid: false };
    }
  });
};
const useUnsavedChangesWarning = (
  formControl,
  defaultRole,
  onUnsavedDataChange,
  onUnsavedDataErrorChange
) => {
  const newUserInfo = useWatch({ control: formControl, name: "newUserInfo" });
  const {
    isDirty,
    errors: { newUserInfo: newUserInfoErrors },
  } = useFormState({ control: formControl });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty]);

  useEffect(() => {
    onUnsavedDataErrorChange(newUserInfoErrors);
  }, [newUserInfoErrors, onUnsavedDataErrorChange]);

  useEffect(() => {
    onUnsavedDataChange(getValidUsers(newUserInfo, defaultRole));
  }, [newUserInfo, onUnsavedDataChange, defaultRole]);
};

export default useUnsavedChangesWarning;
